module.exports = __webpack_public_path__ + "img/title-welcome.86cf9994.png";